import _extends from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["mapCoordinates", "query", "height", "className"];
var __jsx = React.createElement;
import mbxClient from '@mapbox/mapbox-sdk';
import mbxGeocoding from '@mapbox/mapbox-sdk/services/geocoding';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import ReactMapGL, { FlyToInterpolator, Marker } from 'react-map-gl';
import { toRem } from "../../utils/Utils";
import 'mapbox-gl/dist/mapbox-gl.css';
import ListingMarkerIcon from "../../public/icons/listing_marker.svg";
const DixuMap = _ref => {
  let {
      mapCoordinates,
      query,
      height,
      className
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-map', className, 'border-radius-lg');
  const {
    0: viewport,
    1: setViewport
  } = useState({
    latitude: 60.1699,
    longitude: 24.9384,
    zoom: 12,
    bearing: 0,
    pitch: 0
  });
  const {
    0: listingCoordinates,
    1: setListingCoordinates
  } = useState({
    latitude: 60.1699,
    longitude: 24.9384
  });
  const baseClient = mbxClient({
    accessToken: process.env.MAPBOX_API_KEY
  });
  const geocodingClient = mbxGeocoding(baseClient);
  const relevanceThreshold = 0.5;
  const onCoordinateChange = _ref2 => {
    let {
      lat,
      lng
    } = _ref2;
    setViewport({
      latitude: lat,
      longitude: lng
    });
    setListingCoordinates({
      longitude: lng,
      latitude: lat
    });
  };
  useEffect(() => {
    if (geocodingClient) {
      const reverseGeocode = async () => {
        const geocodingQuery = geocodingClient.forwardGeocode({
          query,
          limit: 1,
          countries: ['FI'],
          language: ['fi']
        });
        const response = await geocodingQuery.send();
        const match = response.body.features[0];
        if (!match || match?.relevance < relevanceThreshold) {
          console.warn(`No match found for ${query}, nearest relevance ${match?.relevance || 'none'}`);
        } else {
          onCoordinateChange({
            lat: match.center[1],
            lng: match.center[0]
          });
        }
      };
      if (!mapCoordinates) {
        reverseGeocode();
      } else {
        onCoordinateChange({
          lat: mapCoordinates[1],
          lng: mapCoordinates[0]
        });
      }
    }
  }, [query, mapCoordinates]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, rest), /*#__PURE__*/React.createElement(ReactMapGL, _extends({
    zoom: viewport.zoom || 12,
    width: "100%",
    height: toRem(height),
    transitionInterpolator: new FlyToInterpolator(),
    onViewportChange: setViewport,
    mapStyle: "mapbox://styles/linearoy/ckh3kzob300gd19n2cqcbzubu",
    mapboxApiAccessToken: process.env.MAPBOX_API_KEY
  }, viewport), /*#__PURE__*/React.createElement(Marker, {
    latitude: listingCoordinates.latitude,
    longitude: listingCoordinates.longitude
  }, /*#__PURE__*/React.createElement(ListingMarkerIcon, {
    style: {
      height: toRem(21)
    }
  }))));
};
DixuMap.defaultProps = {
  mapCoordinates: undefined,
  query: undefined,
  height: '288'
};
export default DixuMap;